import React, { useState, useEffect } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import "./App.css";

import Header from "./components/Header";
import Login from "./components/Login";
import Tipo from "./components/Tipo";
import Formulario from "./components/Formulario";
import FormularioExamen from "./components/FormularioExamen";
import FormularioDiplomas from "./components/FormularioDiplomas";
import FormaPago from "./components/FormaPago";
import DashboardCajero from './components/DashboardCajero'; 
import { API_BASE } from "./config";

function App() {
  // Estado de los checkboxes
  const [checked, cambiarChecked] = useState({
    c1: false, c2: false, c3: false, c4: false, c5: false,
    c6: false, c7: false, c8: false, c9: false, c10: false,
    c11: false, c12: false, c13: false, c14: false, c15: false,
    c16: false, c17: false, c18: false, c19: false, c20: false,
    c21: false,
  });

  const [catalogoBD, cambiarCatalogoBD] = useState([]);

  useEffect(() => {
    const obtenerConceptos = async () => {
      try {
        const respuesta = await fetch(`${API_BASE}/wMultipagosObtenerConceptos.php`);
        const resultado = await respuesta.json();
        
        if (resultado.success) {
          cambiarCatalogoBD(resultado.data);
        }
      } catch (error) {
        console.error("Error al cargar los conceptos:", error);
      }
    };

    obtenerConceptos();
  }, []);

  const conceptos = catalogoBD.map((item) => ({
    ...item,
    checked: checked[item.id] || false,
  }));

  const conceptosGenerales = conceptos.filter(c => c.categoria === 'GENERAL');
  const conceptosExamenes = conceptos.filter(c => c.categoria === 'EXAMENES');
  const conceptosDiplomas = conceptos.filter(c => c.categoria === 'EGRESADOS');

  const [pagar, cambiarPagar] = useState(false);
  const [tablaConceptos, cambiarTablaConceptos] = useState([]);
  const [precio, cambiarPrecio] = useState(0);
  const [datospago, cambiarDatosPago] = useState({
    referencia: "",
    importe: "",
    key: "",
  });
  const [claves, cambiarClaves] = useState([]);

  // --- NUEVO: RECUPERAMOS DATOS DEL STORAGE AL CARGAR ---
  const [alumno, modificarAlumno] = useState(() => {
    const alumnoGuardado = sessionStorage.getItem("alumnoStorage");
    return alumnoGuardado ? JSON.parse(alumnoGuardado) : { codigo: "", nombre: "" };
  });

  const [login, cambiarLogin] = useState(() => {
    const loginGuardado = sessionStorage.getItem("loginStorage");
    return loginGuardado === "true"; 
  });
// --- NUEVO: ESTADO PARA CONTROLAR EL FORMULARIO DEL CAJERO ---
  const [esCajero, setEsCajero] = useState(false);

  // --- NUEVO: GUARDAMOS EN EL STORAGE CUANDO HAY CAMBIOS ---
  useEffect(() => {
    sessionStorage.setItem("alumnoStorage", JSON.stringify(alumno));
  }, [alumno]);

  useEffect(() => {
    sessionStorage.setItem("loginStorage", login);
  }, [login]);

  return (
    <BrowserRouter>
      <Header
        alumno={alumno}
        modificarAlumno={modificarAlumno}
        login={login}
        cambiarLogin={cambiarLogin}
        cambiarChecked={cambiarChecked}
        cambiarPagar={cambiarPagar}
        cambiarPrecio={cambiarPrecio}
        cambiarClaves={cambiarClaves}
        activarModuloCajero={setEsCajero}
      />
      <Switch>
        <Route
          exact
          path="/"
          render={() => (
            <Login
              alumno={alumno}
              modificarAlumno={modificarAlumno}
              cambiarLogin={cambiarLogin}
              cambiarDatosPago={cambiarDatosPago}
              esCajero={esCajero}       /* <--- NUEVO */
              setEsCajero={setEsCajero} /* <--- NUEVO */
            />
          )}
        />
        
        <Route 
          exact 
          path="/dashboard-cajero" 
          component={DashboardCajero} 
        />
        
        <Route
          exact
          path="/tipo"
          render={() => (
            <Tipo
              conceptos={conceptos}
              alumno={alumno}
              precio={precio}
              cambiarPrecio={cambiarPrecio}
              datospago={datospago}
              cambiarDatosPago={cambiarDatosPago}
              claves={claves}
              cambiarClaves={cambiarClaves}
              checked={checked}
              cambiarChecked={cambiarChecked}
              cambiarPagar={cambiarPagar}
              cambiarTablaConceptos={cambiarTablaConceptos}
            />
          )}
        />
        <Route
          exact
          path="/formulario-otros"
          render={() => (
            <Formulario
              conceptos={conceptosGenerales}
              alumno={alumno}
              precio={precio}
              cambiarPrecio={cambiarPrecio}
              datospago={datospago}
              cambiarDatosPago={cambiarDatosPago}
              claves={claves}
              cambiarClaves={cambiarClaves}
              checked={checked}
              cambiarChecked={cambiarChecked}
              cambiarPagar={cambiarPagar}
              pagar={pagar}
              tablaConceptos={tablaConceptos}
              cambiarTablaConceptos={cambiarTablaConceptos}
            />
          )}
        />
        <Route
          exact
          path="/formulario-examenes"
          render={() => (
            <FormularioExamen
              conceptos={conceptosExamenes}
              precio={precio}
              cambiarPrecio={cambiarPrecio}
              alumno={alumno}
              cambiarDatosPago={cambiarDatosPago}
              tablaConceptos={tablaConceptos}
              cambiarTablaConceptos={cambiarTablaConceptos}
              cambiarPagar={cambiarPagar}
            />
          )}
        />
        <Route
          exact
          path="/formulario-diplomas"
          render={() => (
            <FormularioDiplomas
              conceptos={conceptosDiplomas}
              precio={precio}
              cambiarPrecio={cambiarPrecio}
              alumno={alumno}
              cambiarDatosPago={cambiarDatosPago}
              tablaConceptos={tablaConceptos}
              cambiarTablaConceptos={cambiarTablaConceptos}
              cambiarPagar={cambiarPagar}
            />
          )}
        />
        <Route
          exact
          path="/formadepago"
          render={() => (
            <FormaPago
              alumno={alumno}
              datospago={datospago}
              tablaConceptos={tablaConceptos}
              cambiarTablaConceptos={cambiarTablaConceptos}
            />
          )}
        />
      </Switch>
    </BrowserRouter>
  );
}

export default App;